module.exports = {
  homepage: {
    heroTitle1: "SmartTeamDev",
    heroTitle2: "Uretim sirketleri icin kurumsal web cozumleri",
    heroSubtitle: "Gunluk operasyonlar icin dijital sistemler tasarlar, kurar ve destekleriz: belge akisi, entegrasyon, otomasyon ve analitik.",
    marqueeText: "Güvenilirlik • Güvenlik • Destek • Portallar • Bulut • Ağ • Entegrasyonlar •",
    heroPrimaryBtn: "Portal sayfasi",
    heroSecondaryBtn: "Iletisim",
    btnLearnPortal: "Portal sayfasi",
    btnContact: "Iletisim",
    scrollDown: "Detaylar",
    whatYouGetEyebrow: "Neler kazanirsiniz",
    whatYouGetTitle: "Ekibin işini hızlandıran hazır çözümler",
    whatYouGetDesc: "Benimsenmesi, ölçeklenmesi ve minimum kesintiyle çalışması kolay projeler geliştiriyoruz.",
    card1Title1: "Kontrol merkezi olarak Portal",
    card1Desc1: "Çalışanlar, iş birimleri ve dış ortaklar için tek erişim noktası.",
    card1Title2: "Görev otomasyonu",
    card1Desc2: "İş akışları, bildirimler ve olay işleyiciler işinizi büyütürken otomatik çalışır.",
    card1Back: "Ölçülebilir sonuçlar: daha az manuel iş, daha hızlı kararlar, şeffaf kontrol.",
    card2Title1: "Güvenilir ağ",
    card2Desc1: "Kararlı ve güvenli kurumsal altyapı için düşünülmüş mimari.",
    card2Title2: "Bulut ve hibrit",
    card2Desc2: "Hem bulutta hem de kurum içi ortamlarda çalışan esnek çözümler.",
    card2Back: "Başlangıçtan ölçeklemeye ve desteğe kadar her aşamada destek.",
    card3Title1: "Güvenlik ve kontrol",
    card3Desc1: "Erişim, şifreleme ve BT uyumluluğuna ileri düzey yaklaşımlar.",
    card3Title2: "Uyarlanabilir destek",
    card3Desc2: "İşle birlikte büyüyen ve değişen gereksinimleri karşılayan çözümler.",
    card3Back: "Güvenebileceğiniz bir yapı: kararlılık, erişilebilirlik ve öngörülebilirlik.",
    servicesEyebrow: "Hizmetler",
    servicesTitle: "En iyi yaptıklarımız",
    servicesDesc: "Bütünsel yaklaşım: portallar, servisler, ağ ve bulut platformları ile şirket büyümesine destek.",
    service1Title: "Kurumsal portallar",
    service1Desc: "İç süreçler, müşteriler ve ortaklar için güvenilir arayüzler.",
    service2Title: "Bulut platformları",
    service2Desc: "Kontrollü göç ve risk azaltma ile hibrit ve bulut çözümleri.",
    service3Title: "Bilgi güvenliği",
    service3Desc: "Veri koruma, erişim kontrolü ve altyapı gereksinimlerine uyum.",
    contactEyebrow: "Bizimle iletişime geçin",
    contactTitle: "Göreviniz hakkında bilgi verin, çözüm önerelim",
    contactDesc: "Değişime hazır, gereksiz teknik borcu olmayan mimariler tasarlarız.",
    contactHighlight1Value: "18 yıl",
    contactHighlight1Label: "kurumsal çözümlerde deneyim",
    contactHighlight2Value: "24/7",
    contactHighlight2Label: "izleme ve destek",
    placeholderName: "İsim",
    placeholderEmail: "Email",
    placeholderPhone: "Telefon",
    placeholderMessage: "Görevi tanımlayın",
    contactBtn: "Talep gönder",
    heroStats: [
      { riIcon: "RiBriefcase4Line", value: "35+", count: 35, label: "Is uygulamasi" },
      { riIcon: "RiPlugLine", value: "10+", count: 10, label: "Entegrasyon alani" },
      { riIcon: "RiServerLine", value: "On-premise", label: "Kurulum" },
      { riIcon: "RiShieldCheckLine", value: "Role-based", label: "Erisim kontrolu" }
    ],
    aboutTitle: "Biz kimiz",
    aboutLead: "SmartTeamDev, endüstriyel işletmeler için kurumsal web sistemleri geliştiren bir ekiptir.",
    aboutText: "Müşterinin kendi altyapısında çalışan dijital araçlar geliştirip dağıtıyoruz: on-premise portallar, iş uygulamaları, entegrasyonlar ve servisler. Uzmanlığımız; güvenilirlik, veri kontrolü ve esnekliğin önemli olduğu üretim ve endüstriyel şirketlerdir.",
    aboutPoints: [
      "Tam döngü ekip: analiz, geliştirme, uygulama, destek",
      "On-premise önce — verileriniz sizde kalır",
      "Üretim ve endüstriyel işletmelerde uzmanlaşma",
      "35+ hazır uygulama ile kendi Portal platformumuz"
    ],
    areasTitle: "Neler gelistiriyoruz",
    areasSubtitle: "Dijitallesme surecinin tamamini kapsayan uc pratik alan",
    companyAreas: [
      {
        href: "/pages/portal",
        riIcon: "RiLayoutGridLine",
        title: "Kurumsal portal",
        description: "Belgeler, gorevler, veriler ve servisler tek arayuzde toplanir.",
        features: ["Masaustu /app", "AD rol modeli", "Moduler apps/* yapisi"]
      },
      {
        href: "/pages/services",
        riIcon: "RiPlug2Line",
        title: "Gelistirme ve entegrasyon",
        description: "1C, bankalar, AD, SKUD, FortMonitor, mesajlasma ve dis API'leri tek akisda birlestiririz.",
        features: ["REST ve proxy entegrasyon", "Planli senkronizasyon", "Loglama ve denetim"]
      },
      {
        href: "/pages/media",
        riIcon: "RiFileList3Line",
        title: "Demo ve dokumantasyon",
        description: "Belirli moduller ve roller icin gercek kullanim senaryolari gosteririz.",
        features: ["Demo senaryolari", "Teknik dokuman", "Uygulama plani"]
      }
    ],
    factsTitle: "Neden SmartTeamDev",
    factsSubtitle: "Uretim ortaminda kritik olan temel kriterler",
    companyFacts: [
      { riIcon: "RiLock2Line", title: "Veri kontrolu", description: "Platform bulut zorunlulugu olmadan sizin altyapinizda calisir." },
      { riIcon: "RiStackLine", title: "Genisleyebilir mimari", description: "Yeni moduller tum sistemi yeniden yazmadan baglanir." },
      { riIcon: "RiShieldCheckLine", title: "Net yetki modeli", description: "Erisim roller, AD gruplari ve sunucu filtreleri ile yonetilir." },
      { riIcon: "RiSettings3Line", title: "Operasyon destegi", description: "Canliya gecis sonrasi guncelleme, uyarlama ve destek veririz." }
    ],
    releaseTitle: "Projeyi nasil canliya aliyoruz",
    releaseSteps: [
      { num: "01", riIcon: "RiSearchLine", title: "Analiz", text: "Surecleri, rolleri, veri kaynaklarini ve zorunlu entegrasyonlari belirleriz." },
      { num: "02", riIcon: "RiGitMergeLine", title: "Tasarim", text: "Modul kapsami, yetki matrisi, entegrasyon modeli ve gecis planini hazirlariz." },
      { num: "03", riIcon: "RiServerLine", title: "Uygulama", text: "Platformu kurar, ayarlari tasir, servisleri baglar ve ekibi egitiriz." },
      { num: "04", riIcon: "RiPulseLine", title: "Surekli isletim", text: "Sistemi stabil tutar ve ihtiyaca gore yeni fonksiyonlar ekleriz." }
    ],
    techTitle: "Teknoloji yığını",
    techSubtitle: "Üretimde kullanılan platform bileşenleri",
    techStack: [
      { riIcon: "RiReactjsLine", title: "Frontend", text: "React 18, Redux Toolkit, Ant Design 5, masaüstü yönlendirme ve widget'lar." },
      { riIcon: "RiNodejsLine", title: "Backend", text: "Node.js 20+, Express, socket.io, EJS ve apps/* için uygulama API'leri." },
      { riIcon: "RiDatabase2Line", title: "Veri", text: "MongoDB sistem ve iş veri ayrımı, Mongoose ve sunucu taraflı filtreler." },
      { riIcon: "RiSettings4Line", title: "Entegrasyonlar", text: "AD/LDAP, 1C, banka API'leri, DaData, Kontur.Focus, FortMonitor, WOPI ve OpenAI." }
    ],
    ctaTitle: "Projenizi goruselim",
    ctaSubtitle: "Kuruluma uygun modul listesi, entegrasyon haritasi ve yol plani hazirlayalim.",
    ctaContactBtn: "Bize yazin",
    ctaLearnMoreBtn: "Portal sayfasi"
  }
};
